import React from 'react';

type PartnerTabType =
  | 'summary'
  | 'jobs'
  | 'payments'
  | 'adjustments'
  | 'withdrawal_requests'
  | 'make_payment'
  | 'verification';

interface Props {
  activeTab: PartnerTabType;
  setActiveTab: React.Dispatch<React.SetStateAction<PartnerTabType>>;
}

const PartnerTabNavigation: React.FC<Props> = ({
  activeTab,
  setActiveTab,
}) => {
  const tabs: { key: PartnerTabType; label: string }[] = [
    { key: 'summary', label: 'Summary' },
    { key: 'jobs', label: 'Jobs' },
    { key: 'payments', label: 'Wallet Transactions' },
    { key: 'adjustments', label: 'Adjustments' },
    { key: 'withdrawal_requests', label: 'Withdrawal Requests' },
    { key: 'make_payment', label: 'Make Payment' },
    { key: 'verification', label: 'Partner Verification' },
  ];

  return (
    <div className="flex gap-6 border-b">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => setActiveTab(tab.key)}
          className={`pb-2 text-sm font-medium ${activeTab === tab.key
              ? 'border-b-2 border-blue-600 text-blue-600'
              : 'text-gray-500 hover:text-gray-700'
            }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default PartnerTabNavigation;
